var React = require('react');

function StepBackward (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144,292.71V464a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V48A16,16,0,0,1,80,32h48a16,16,0,0,1,16,16V292.7Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384,64V448c0,27.4-31.9,41.7-52.5,24.6L144,298.34V213.65L331.5,39.41C352.1,22.31,384,36.61,384,64Z","className":"fa-primary","key":2})]);
}

StepBackward.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = StepBackward;

StepBackward.default = StepBackward;
